import React, { Fragment, useEffect, useState } from 'react';
import { Button, Col, Container, Input, Label, Row, Table } from 'reactstrap';
import { toast } from "react-toastify";
import _ from 'lodash';
import { FilterSelect, ServiceThreadSpinner } from '.';
import { api, filterHelpers } from '../utils';
import { confirmAlert } from "react-confirm-alert";

export default function ManageSites() {
   const ALL_OPTS = { value: 0, label: "-- Select --" };
   const SITE_MODEL = { id: 0, countLoc: false, siteId: "", siteWithDesc: "", typeId: 1, typeDesc: "internal" };
   const [addConsign, setAddConsign] = useState(false);
   const [addCount, setAddCount] = useState(false);
   const [addList, setAvailableList] = useState([]);
   const [addSite, setAddSite] = useState(SITE_MODEL);
   const [editConsign, setEditConsign] = useState(false);
   const [editCount, setEditCount] = useState(false);
   const [editSite, setEditSite] = useState(SITE_MODEL);
   const [siteList, setSiteList] = useState([]);
   const [spinXfer, setSpinXfer] = useState(true);
   const [filters, setFilters] = useState([
      { filterName: "editSite", value: ALL_OPTS },
      { filterName: "addSite", value: ALL_OPTS }
   ]);

   useEffect(() => {
      runQuery();
      // eslint-disable-next-line react-hooks/exhaustive-deps
   }, [])

   useEffect(() => {
      if (addConsign && addCount)
         setAddCount(!addCount)
      // eslint-disable-next-line react-hooks/exhaustive-deps
   }, [addConsign])

   useEffect(() => {
      if (addCount && addConsign)
         setAddConsign(!addConsign)
      // eslint-disable-next-line react-hooks/exhaustive-deps
   }, [addCount])

   useEffect(() => {
      if (editConsign && editCount)
         setEditCount(!editCount)
      // eslint-disable-next-line react-hooks/exhaustive-deps
   }, [editConsign])

   useEffect(() => {
      if (editCount && editConsign)
         setEditConsign(!editConsign)
      // eslint-disable-next-line react-hooks/exhaustive-deps
   }, [editCount])

   function DeleteSite() {
      setSpinXfer(true);
      api.post(`Transfer/DeleteTransferSite/${editSite.id}`)
         .then((response) => {
            if (response.data.success) {
               toast.success("Transfer Site successfully deleted.")
               runQuery();
            } else {
               toast.error(response.data.message);
               setSpinXfer(false);
            }
         })
         .catch((error) => {
            api.catchHandler(error);
            toast.error(error);
            setSpinXfer(false);
         });
   }

   function onAddChange(newFilterValue) {
      const addItm = _.find(addList, (x) => x.value === newFilterValue.value);
      const editItm = _.find(siteList, (x) => x.value === 0);
      let newFilters = filterHelpers.getFilters(filters, {
         filterName: "addSite",
         value: addItm,
      });
      newFilters = filterHelpers.getFilters(newFilters, {
         filterName: "editSite",
         value: editItm,
      });
      setFilters(newFilters);

      setAddConsign(false);
      setAddCount(false);
      if (newFilterValue.value === 0) { // Not adding, reset
         setAddSite(SITE_MODEL);
      }
      else { // Reset the edit site, and get the selected site
         setEditSite(SITE_MODEL);
         setEditConsign(false);
         setEditCount(false);

         let changes = Object.assign({}, addSite);
         changes.siteId = newFilterValue.value;
         changes.siteWithDesc = newFilterValue.label;
         setAddSite(changes);
      }
   }

   function onSiteChange(newFilterValue) {
      const editItm = _.find(siteList, (x) => x.value === newFilterValue.value);
      const addItm = _.find(addList, (x) => x.value === 0);
      let newFilters = filterHelpers.getFilters(filters, {
         filterName: "editSite",
         value: editItm,
      });
      newFilters = filterHelpers.getFilters(newFilters, {
         filterName: "addSite",
         value: addItm,
      });
      setFilters(newFilters);

      if (newFilterValue.value === 0) { // Not editing, reset
         setEditSite(SITE_MODEL);
         setEditConsign(false);
         setEditCount(false);
      }
      else {
         //Reset the add site
         setAddSite(SITE_MODEL);
         setAddConsign(false);
         setAddCount(false);

         // Get the selected site and set it up
         const s = _.find(siteList, (x) => x.value === newFilterValue.value);
         setEditCount(s.countLoc);
         if (s.typeId === 2)
            setEditConsign(true);
         else
            setEditConsign(false);

         let changes = Object.assign({}, editSite);
         changes.id = newFilterValue.value;
         changes.countLoc = s.countLoc;
         changes.siteId = s.siteId;
         changes.siteWithDesc = newFilterValue.label;
         changes.typeId = s.typeId
         changes.typeDesc = s.typeDesc
         setEditSite(changes);
      }
   }

   function onSiteUpdate() {
      if (!editSite || editSite.id === 0) {
         toast.error("Please select a site to edit");
         return;
      }
      let payload = Object.assign({}, editSite);
      payload.countLoc = editCount;
      payload.typeId = editConsign ? 2 : 1
      payload.typeDesc = editConsign ? "Consigned" : "Internal"
      SaveTransferSite(payload);
   }

   function runQuery() {
      setSpinXfer(true);
      api
         .fetch(`Transfer/LoadTransferSites`)
         .then((response) => {
            if (response.data.success) {
               const exList = _.concat([ALL_OPTS],
                  _.map(response.data.editSites, (e) => ({
                     value: e.id,
                     label: e.siteWithDesc,
                     countLoc: e.countLoc,
                     siteId: e.siteId,
                     typeId: e.typeId,
                     typeDesc: e.typeDesc
                  })));
               const avList = _.concat([ALL_OPTS],
                  _.map(response.data.addSites, (a) => ({
                     value: a.siteId,
                     label: a.siteWithDesc
                  })));
               return { exList: exList, avList: avList };
            } else {
               toast.error(response.data.message);
            }
         })
         .then(({ exList, avList }) => {
            setSiteList(exList);      // current transfer sites
            setAvailableList(avList); // sites available to add
         })
         .catch((error) => {
            api.catchHandler(error);
            toast.error(error);
         })
         .finally(() => {
            setAddSite(SITE_MODEL);
            setEditSite(SITE_MODEL);
            const addItm = _.find(addList, (x) => x.value === 0);
            const editItm = _.find(siteList, (x) => x.value === 0);
            let newFilters = filterHelpers.getFilters(filters, {
               filterName: "addSite",
               value: addItm,
            });
            newFilters = filterHelpers.getFilters(newFilters, {
               filterName: "editSite",
               value: editItm,
            });
            setFilters(newFilters);
            setSpinXfer(false);
         });
   }

   function AddTransferSite() {
      if (!addSite || addSite.siteId === "") {
         toast.error("Please select a site to be added");
         return;
      }
      let payload = Object.assign({}, addSite);
      payload.id = 0;
      payload.countLoc = addCount;
      payload.typeId = addConsign ? 2 : 1
      payload.typeDesc = addConsign ? "Consigned" : "Internal"
      SaveTransferSite(payload);
   }

   function SaveTransferSite(payload) {
      setSpinXfer(true);
      api.post('Transfer/SaveTransferSite', payload)
         .then((response) => {
            if (response.data.success) {
               toast.success("Transfer Site saved successfully!")
               runQuery();
            } else {
               toast.error(response.data.message);
               setSpinXfer(false);
            }
         })
         .catch((error) => {
            api.catchHandler(error);
            toast.error(error);
            setSpinXfer(false);
         });
   }

   const ShowDeleteModal = () => {
      if (!editSite || editSite.id === 0) {
         toast.error("Please select a Transfer Site to delete");
         return;
      }

      confirmAlert({
         title: "Confirm Deletion",
         message: `Are you sure you want to delete the ${editSite.siteId} transfer site?`,
         buttons: [
            { label: "Yes", onClick: () => { DeleteSite() } },
            { label: "No" }
         ]
      });
   }

   return (
      <Container fluid>
         <Row>
            <Col>
               <Fragment>
                  <ServiceThreadSpinner on={spinXfer}>
                     <Row className="px-2 py-2">
                        <Col xxl={{ offset: 0, size: 12 }}>
                           <Table className="transparent-background my-0">
                              <tbody>
                                 {addList && addList.length ? (
                                    <tr>
                                       <td className="transparent-background data-cell noWrap h6 width115px">
                                          Available:
                                       </td>
                                       <td className="transparent-background" width="500px">
                                          <FilterSelect
                                             filterName="addSite"
                                             options={addList}
                                             value={filterHelpers.getValue(filters, "addSite")}
                                             onChangeCallback={e => onAddChange(e)}
                                          />
                                       </td>
                                       <td className="transparent-background data-cell"></td>
                                    </tr>
                                 ) : null}
                                 {siteList && siteList.length ? (
                                    <tr>
                                       <td className="transparent-background data-cell noWrap h6 width115px">
                                          Sites:
                                       </td>
                                       <td className="transparent-background" width="500px">
                                          <FilterSelect
                                             filterName="editSite"
                                             options={siteList}
                                             value={filterHelpers.getValue(filters, "editSite")}
                                             onChangeCallback={e => onSiteChange(e)}
                                          />
                                       </td>
                                       <td className="transparent-background data-cell"></td>
                                    </tr>
                                 ) : null}
                              </tbody>
                           </Table>
                        </Col>
                     </Row>

                     {addSite && addSite.siteId !== "" ? (
                        <div>
                           <Row className="px-0 py-0">
                              <Table className="transparent-background data-table">
                                 <tbody>
                                    <tr>
                                       <td className="transparent-background data-cell width40px"></td>
                                       <td className="transparent-background data-cell noWrap h6 width500px">
                                          Site: {addSite.siteWithDesc}
                                       </td>
                                       <td className="transparent-background data-cell"></td>
                                    </tr>
                                    <tr>
                                       <td className="transparent-background data-cell width40px"></td>
                                       <td className="transparent-background data-cell width500px">
                                          <Input
                                             type="checkbox"
                                             name="addCountLoc"
                                             checked={addCount}
                                             onChange={(e) => setAddCount(!addCount)}
                                          /> &nbsp;&nbsp;&nbsp;
                                          <Label for="addCountLoc" className="h6">This site does Inventory Counts</Label>
                                       </td>
                                       <td className="transparent-background data-cell"></td>
                                    </tr>
                                    <tr>
                                       <td className="transparent-background data-cell width40px"></td>
                                       <td className="transparent-background data-cell width500px">
                                          <Input
                                             type="checkbox"
                                             name="addConsigned"
                                             checked={addConsign}
                                             onChange={(e) => setAddConsign(!addConsign)}
                                          /> &nbsp;&nbsp;&nbsp;
                                          <Label for="addConsigned" className="h6">This is a Consignment Site</Label>
                                       </td>
                                       <td className="transparent-background data-cell"></td>
                                    </tr>
                                    <tr>
                                       <td className="transparent-background data-cell width40px"></td>
                                       <td className="transparent-background data-cell width500px">
                                          <Button
                                             title="Add Site"
                                             className="shredButton"
                                             onClick={() => AddTransferSite()}
                                          >
                                             Add Transfer Site
                                          </Button>
                                       </td>
                                       <td className="transparent-background data-cell"></td>
                                    </tr>
                                 </tbody>
                              </Table>
                           </Row>
                        </div>
                     ) : null}

                     {editSite && editSite.id > 0 ? (
                        <div>
                           <Row className="px-0 py-0">
                              <Table className="transparent-background data-table">
                                 <tbody>
                                    <tr>
                                       <td className="transparent-background data-cell width40px"></td>
                                       <td className="transparent-background data-cell noWrap h6 width500px">
                                          Site: {editSite.siteWithDesc}
                                       </td>
                                       <td className="transparent-background data-cell"></td>
                                    </tr>
                                    <tr>
                                       <td className="transparent-background data-cell width40px"></td>
                                       <td className="transparent-background data-cell width500px">
                                          <Input
                                             type="checkbox"
                                             name="editCountLoc"
                                             checked={editCount}
                                             onChange={(e) => setEditCount(!editCount)}
                                          /> &nbsp;&nbsp;&nbsp;
                                          <Label for="editCountLoc" className="h6">This site does Inventory Counts</Label>
                                       </td>
                                       <td className="transparent-background data-cell"></td>
                                    </tr>
                                    <tr>
                                       <td className="transparent-background data-cell width40px"></td>
                                       <td className="transparent-background data-cell width500px">
                                          <Input
                                             type="checkbox"
                                             name="editConsigned"
                                             checked={editConsign}
                                             onChange={(e) => setEditConsign(!editConsign)}
                                          /> &nbsp;&nbsp;&nbsp;
                                          <Label for="editConsigned" className="h6">This is a Consignment Site</Label>
                                       </td>
                                       <td className="transparent-background data-cell"></td>
                                    </tr>
                                    <tr>
                                       <td className="transparent-background data-cell width40px"></td>
                                       <td className="transparent-background data-cell width500px">
                                          <Button
                                             title="Update"
                                             className="shredButton"
                                             onClick={() => onSiteUpdate()}
                                          >
                                             Update
                                          </Button>
                                          &nbsp;&nbsp;&nbsp;
                                          <Button
                                             title="Delete"
                                             className="shredButton"
                                             onClick={() => ShowDeleteModal()}
                                          >
                                             Delete
                                          </Button>
                                       </td>
                                       <td className="transparent-background data-cell"></td>
                                    </tr>
                                 </tbody>
                              </Table>
                           </Row>
                        </div>
                     ) : null}

                  </ServiceThreadSpinner>
               </Fragment>
            </Col>
         </Row>
      </Container >
   );
}
